/** Land Records tile sources — one Mapbox vector source per state. */

export const DEFAULT_AL_PARCEL_TILES_URL =
  'https://public-land-tiles.atl1.cdn.digitaloceanspaces.com/parcels/landrecords/al/2026-09/tiles/{z}/{x}/{y}.pbf';

export const DEFAULT_MS_PARCEL_TILES_URL =
  'https://public-land-tiles.atl1.cdn.digitaloceanspaces.com/parcels/landrecords/ms/2026-09/tiles/{z}/{x}/{y}.pbf';

export const DEFAULT_TN_PARCEL_TILES_URL =
  'https://public-land-tiles.atl1.cdn.digitaloceanspaces.com/parcels/landrecords/tn/2026-09/tiles/{z}/{x}/{y}.pbf';

export const DEFAULT_GA_PARCEL_TILES_URL =
  'https://public-land-tiles.atl1.cdn.digitaloceanspaces.com/parcels/landrecords/ga/2026-09/tiles/{z}/{x}/{y}.pbf';

export const LANDRECORDS_PARCEL_SOURCES = [
  { id: 'regrid-parcels', state: 'al', tilesUrl: DEFAULT_AL_PARCEL_TILES_URL },
  { id: 'regrid-parcels-ms', state: 'ms', tilesUrl: DEFAULT_MS_PARCEL_TILES_URL },
  { id: 'regrid-parcels-tn', state: 'tn', tilesUrl: DEFAULT_TN_PARCEL_TILES_URL },
  { id: 'regrid-parcels-ga', state: 'ga', tilesUrl: DEFAULT_GA_PARCEL_TILES_URL }
];

export const PARCEL_SOURCE_IDS = LANDRECORDS_PARCEL_SOURCES.map((source) => source.id);

export function parcelLayerIds(sourceId) {
  return {
    outline: `${sourceId}-outline`,
    fillInteractive: `${sourceId}-fill-interactive`,
    highlight: `${sourceId}-highlight`,
    fillHighlight: `${sourceId}-fill-highlight`
  };
}

export function parcelHitLayersForSources(sourceIds) {
  const layers = [];
  (sourceIds || []).forEach((sourceId) => {
    const ids = parcelLayerIds(sourceId);
    layers.push(ids.fillInteractive, ids.outline);
  });
  return layers;
}

export function allParcelLayerIds(sourceIds = PARCEL_SOURCE_IDS) {
  const layers = [];
  sourceIds.forEach((sourceId) => {
    const ids = parcelLayerIds(sourceId);
    layers.push(ids.fillHighlight, ids.highlight, ids.fillInteractive, ids.outline);
  });
  return layers;
}

export function isCustomParcelTilesUrl(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return false;
  return !/\/parcels\/landrecords\/[a-z]{2}\//i.test(trimmed);
}

function sourceFromUrl(tilesUrl, index) {
  const match = String(tilesUrl).match(/\/parcels\/landrecords\/([a-z]{2})\//i);
  const state = match ? match[1].toLowerCase() : `s${index}`;
  const id = state === 'al' ? 'regrid-parcels' : `regrid-parcels-${state}`;
  return { id, state, tilesUrl };
}

/** Resolve the Mapbox sources to add. Empty env → none. Custom URL → one source. CDN → AL+MS+TN+GA catalog. */
export function resolveParcelSources({ tilesUrl = '', tilesUrls = '' } = {}) {
  const listed = String(tilesUrls || '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  if (listed.length) {
    return listed.map((url, index) => sourceFromUrl(url, index));
  }
  const url = String(tilesUrl || '').trim();
  if (!url) return [];
  if (isCustomParcelTilesUrl(url)) {
    return [{ id: 'regrid-parcels', state: 'custom', tilesUrl: url }];
  }
  return LANDRECORDS_PARCEL_SOURCES.map((source) => ({ ...source }));
}

/** Back-compat: old overlay mocks only have tilesUrl. */
export function overlaySources(overlay) {
  if (overlay && Array.isArray(overlay.sources) && overlay.sources.length) {
    return overlay.sources;
  }
  if (overlay && overlay.tilesUrl) {
    return [{ id: 'regrid-parcels', state: 'custom', tilesUrl: overlay.tilesUrl }];
  }
  return [];
}

export function isParcelTileSourceId(sourceId) {
  return String(sourceId || '').startsWith('regrid-parcels');
}
